<template>
  <ContentWrap>
    <el-form ref="queryFormRef" :inline="true" :model="queryParams" class="-mb-15px" label-width="68px">
      <el-form-item label="砍价状态" prop="status">
        <el-select v-model="queryParams.status" class="!w-200px" clearable placeholder="请选择砍价状态">
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.PROMOTION_BARGAIN_RECORD_STATUS)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间" prop="createTime">
        <el-date-picker
          v-model="queryParams.createTime"
          class="!w-240px"
          end-placeholder="结束日期"
          start-placeholder="开始日期"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
          :default-time="[new Date('1 00:00:00'), new Date('1 23:59:59')]"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery"><Icon class="mr-5px" icon="ep:search" />搜索</el-button>
        <el-button @click="resetQuery"><Icon class="mr-5px" icon="ep:refresh" />重置</el-button>
        <el-button @click="goBack">返回</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column label="编号" min-width="70" prop="id" />
      <el-table-column label="发起用户" min-width="140">
        <template #default="scope">
          <el-image :src="scope.row.avatar" class="mr-5px h-20px w-20px align-middle" />
          <span>{{ scope.row.nickname }}</span>
        </template>
      </el-table-column>
      <el-table-column label="发起时间" align="center" prop="createTime" :formatter="dateFormatter" width="180" />
      <el-table-column label="砍价活动" min-width="150" prop="activity.name" />
      <el-table-column label="最低价" min-width="100" prop="activity.bargainMinPrice" :formatter="fenToYuanFormat" />
      <el-table-column label="当前价" min-width="100" prop="bargainPrice" :formatter="fenToYuanFormat" />
      <el-table-column label="砍价状态" align="center" prop="status">
        <template #default="scope">
          <dict-tag :type="DICT_TYPE.PROMOTION_BARGAIN_RECORD_STATUS" :value="scope.row.status" />
        </template>
      </el-table-column>
      <el-table-column label="结束时间" align="center" prop="endTime" :formatter="dateFormatter" width="180" />
      <el-table-column label="订单编号" align="center" prop="orderId" />
    </el-table>
    <Pagination :total="total" v-model:page="queryParams.pageNo" v-model:limit="queryParams.pageSize" @pagination="getList" />
  </ContentWrap>
</template>

<script setup lang="ts">
import { getBargainRecordPage } from '@/api/merchant/promotion'
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import { dateFormatter } from '@/utils/formatTime'
import { fenToYuanFormat } from '@/utils/formatter'

defineOptions({ name: 'MerchantBargainRecord' })

const router = useRouter()
const loading = ref(true)
const total = ref(0)
const list = ref([])
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  status: undefined as number | undefined,
  createTime: [] as string[]
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await getBargainRecordPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value?.resetFields()
  handleQuery()
}

const goBack = () => router.push({ name: 'MerchantPromotion' })

onMounted(() => {
  getList()
})
</script>
